module.exports = __webpack_public_path__ + "assets/6cbee8b3789ad85a9f7ce6f7179d04e7.png";